import { IOption } from 'components/input/selectInput';
import { ReactElement } from 'react';
import {
  IIngredientDocBufferDataPoint,
  IIngredientDocInfo,
  IIngredientDTO,
  LiquidClassDTO,
  VendorDTO,
} from 'business/models/Models';
import { BufferCalculationType } from 'business/BufferCalculationType';
import { RowExtraInfo } from 'components/customComponents/Controls/RMTable';

export const STOCK_COLUMNS: { accessor: string; Header: string; className?: string }[] = [
  { accessor: 'active', Header: 'Active', className: 'stockCell-1 alignContent' },
  { accessor: 'id', Header: 'Stock Id', className: 'stockCell-2 alignContent' },
  {
    accessor: 'stockNumber',
    Header: 'Stock Number',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'stockConcentration',
    Header: 'Stock Conc.',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'concentrationUnits',
    Header: 'Conc. Unit',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'lowConcentration',
    Header: 'Low Conc.',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'highConcentration',
    Header: 'High Conc.',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'liquidClassId',
    Header: 'Liquid Class',
    className: 'stockCell-3 alignContent',
  },
  { accessor: 'isBuffer', Header: 'Buffer', className: 'stockCell-1 alignContent' },
  { accessor: 'stockPh', Header: 'Stock pH', className: 'stockCell-2 alignContent' },
  { accessor: 'vendorId', Header: 'Vendor', className: 'stockCell-4 alignContent' },
  {
    accessor: 'vendorPartNumber',
    Header: 'Vendor Part #',
    className: 'stockCell-3 alignContent',
  },
  {
    accessor: 'dispenseOrder',
    Header: 'Dispense Order',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'bufferDefault',
    Header: 'Buffer Default',
    className: 'stockCell-2 alignContent',
  },
  {
    accessor: 'nonBufferDefault',
    Header: 'Non Buffer Default',
    className: 'stockCell-2 alignContent',
  },
  { accessor: 'isPrepared', Header: 'Prepared', className: 'stockCell-2 alignContent' },
  {
    accessor: 'stockLocation',
    Header: 'Stock Location',
    className: 'stockCell-3 alignContent',
  },
];

export const BUFFER_DATA_COLUMNS: {
  accessor: string;
  Header: string;
  className?: string;
}[] = [
  { accessor: 'pH', Header: 'pH' },
  { accessor: 'ratio', Header: 'Acid/Base Ratio' },
];

export type UseGetStocksTableDataProps = {
  onCellChanged: (e: any, id: number) => void;
  vendors: VendorDTO[];
  liquidClasses: LiquidClassDTO[];
  ingInfo: IIngredientDTO;
  concUnits: IOption[];
};

export type StockPropsInputMap = {
  [key: string]: {
    type: React.HTMLInputTypeAttribute;
    options?: IOption[];
    disabled?: boolean;
    value?: any;
  };
};

export type StockTableData = { [key: string]: ReactElement };
export type TitrationRowRendererProps = {
  bufferDataPoints: IIngredientDocBufferDataPoint[];
  handleDataPointChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    pointId: number,
  ) => void;
};

export type ChartData = { x: number; y: number };
export interface IngredientChartProps {
  xLabels: number[];
  yLabels: number[];
  chartData: ChartData[];
  xTitle: string;
  yTitle: string;
}

export const NUM_OF_LABELS = 5;

export const BUFFER_CALCULATION_TYPES = [
  {
    value: BufferCalculationType.pKa.ID,
    title: 'pKa',
  },
  {
    value: BufferCalculationType.Interpolate.ID,
    title: 'Interpolate',
  },
];

export interface BufferDataTableProps {
  ingId: number;
  bufferDataPoints: IIngredientDocBufferDataPoint[];
  errors: RowExtraInfo;
}

export type UseGetHeaderButtonsProps = {
  setError: (error: { show: boolean; msg: string }) => void;
  ingredientInfo: IIngredientDocInfo;
  closeModal: () => void;
};

export const infoRequiredFields = [
  { accessor: 'longName', title: 'Long Name' },
  { accessor: 'shortName', title: 'Short Name' },
];
